import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
        private router: Router,
        private authService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        try {
            const raw = localStorage.getItem('currentUser');
            if (raw) {
                const currentUser = JSON.parse(raw);
                if (currentUser && !this.authService.getAdminSnapshot()) {
                    this.authService.setAdmin(currentUser);
                }
                return true;
            }
        } catch {
            /* fall through to login */
        }
        this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
